// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { forma as _forma } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the forma chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 984122
 * Chain Name: Forma
 * Default Block Explorer: https://explorer.forma.art
 * Default RPC URL: https://rpc.forma.art
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { forma } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: forma,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const forma = createCommon({
	..._forma,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
